import { useAPI } from 'src/services/api';

export default function useFetchAddressByZip() {
  const api = useAPI();

  async function fetchAddressByZip(zip = '') {
    try {
      if (zip.length === 5) {
        const result = await api.get(`/address/${zip}`);

        return result.data;
      }
    } catch (err) {
      if (err.response) {
        console.error(err.response.data);
      } else {
        console.error(err.message);
      }
    }
  }

  return fetchAddressByZip;
}
